// extracted by mini-css-extract-plugin
export default {"main":"signup_main__FTnKS","container":"signup_container__UclaR","button_container":"signup_button_container__L28b7","main_container":"signup_main_container__T1KOG"};